import { Component } from '@angular/core';

@Component({
    selector: 'lca-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent {
}
